<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__left">
        <img class="footer__left__img" src="/img/adx/adx-red.png" alt="">
        <div class="footer__left__copyright small-font">
          Copyright © {{currentYear()}} ADXASIA. All Rights Reserved.
        </div>
      </div>
      <div class="footer__right">
        <div class="footer__right__menu">
          <div @click.stop="goTo('aboutus')" class="menu__item subhead">About</div>
          <div @click.stop="goTo('tos')" class="menu__item subhead">Terms</div>
          <!-- <div class="menu__item subhead">Privacy</div> -->
          <div @click.stop="goTo('contactus')" class="menu__item subhead">Contact us</div>
        </div>
        <div class="footer__right__medsos">
          <div class="medsos__item" @click.stop="goToLink('https://www.facebook.com/pg/ADXAsia.co.id/')">
            <i class="adx-ic_facebook"></i>
          </div>
          <div class="medsos__item" @click.stop="goToLink('https://www.instagram.com/adxasia/')">
            <i class="adx-ic_instagram"></i>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import moment from 'moment'

export default {
  methods: {
    goTo(link) {
      this.$router.push({ name: link});
    },
    goToLink(link) {
      window.open(link, '_blank')
    },
    currentYear() {
      return moment().format('YYYY')
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>